<template>
    <div class="row">
        <div class="col-md-12">
        <h1 style="text-align:center">Select an indicator to graph:</h1>
        </div>
    </div>
    <div class="row">
            <div class="col-md-12">
            <!-- financial indicators -->
            <div class="panel panel-default" id="financialindicatorsdrawer">
                <div class="panel-heading clickable" href="#finance" data-toggle="collapse" >
                    <h2 class="panel-title">
                        <a href="#finance" data-toggle="collapse" aria-expanded="true">
                            Financial Performance
                            <button  type="button" class="btn financebutton" id="financebutton" style="background:none;float:right;">
                                <span class="glyphicon glyphicon-collapse-down" aria-hidden="true"></span>
                            </button>
                        </a>
                    </h2>
                </div>
                <div class="panel-body collapse" id="finance">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px;">
                                <div class="panel-heading">
                                    <h3 class="panel-title" >Profitability Indicators</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Profitability')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px;">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Liquidity Indicators</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Liquidity')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px;">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Capital Structure Indicators</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Capital Structure')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px;">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Public Health Emergency Funding</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'COVID-19 PHE Funding')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
        </div>

        <div class="row">
            <div class="col-md-12">
            <!-- Service Line -->
            <div class="panel panel-default" id="servicedrawer">
                <div class="panel-heading clickable" href="#service" data-toggle="collapse" >
                    <h2 class="panel-title">
                        <a href="#service" data-toggle="collapse" aria-expanded="true">
                            Service Line
                            <button  type="button" class="btn servicebutton" id="servicebutton" style="background:none;float:right;">
                                <span class="glyphicon glyphicon-collapse-down" aria-hidden="true"></span>
                            </button>

                        </a>
                    </h2>
                </div>
                <div class="panel-body collapse " id="service">
                    <div class="row">                        
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Inpatient</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Inpatient')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Outpatient</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Outpatient')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
           </div>
        </div>

           <div class="row">
            <div class="col-md-12">
            <!-- Operations -->
            <div class="panel panel-default" id="operationsdrawer">
                <div class="panel-heading clickable" href="#operations" data-toggle="collapse" >
                    <h2 class="panel-title">
                        <a href="#operations" data-toggle="collapse" aria-expanded="true">
                            Operations
                            <button  type="button" class="btn operationsbutton" id="operationsbutton" style="background:none;float:right;">
                                <span class="glyphicon glyphicon-collapse-down" aria-hidden="true"></span>
                            </button>
                        </a>
                    </h2>
                </div>
                <div class="panel-body collapse " id="operations">
                    <div class="row">
                        
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Growth</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Growth')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-default" style="min-height:300px">
                                <div class="panel-heading" >
                                    <h3 class="panel-title">Labor</h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Labor')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="panel panel-default" style="min-height:300px">
                                    <div class="panel-heading">
                                        <h3 class="panel-title">Other</h3>
                                    </div>
                                    <div class="panel-body">
                                        <p>
                                            <button class="btn-block" @click="setIndicator(indicator)" v-for="indicator in arrindicators.filter(ind=>ind.Domain == 'Other')" :value="indicator.id">
                                        {{ indicator.indicatorStringAbbrv }}
                                      </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
        </div>
</template>

<script type="module">

</script>

<script setup>

import { toRaw, onMounted, watch } from "vue";
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'


const {  setIndicator , fetchIndicators, chartType} = useVisualizationsStore()
const { arrindicators } = storeToRefs(useVisualizationsStore())
var store = useVisualizationsStore()
fetchIndicators();



watch(arrindicators, async () => {
    if ( chartType == 'fdi' && arrindicators.length !== 0 ) {
        const arrInd = store.arrindicators;
        //console.log(arrInd)
        var fdi_indicator = null;
        arrInd.forEach( (ind) => {
            console.log(ind)
            if (ind.indicator == 'fdicat') {
                fdi_indicator = ind;
            }
        });
        setIndicator(fdi_indicator);
    }
  
})

</script>